import { useEffect } from 'react';
import { useApiGet } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { FormTemplate } from '../../models/FormTemplate';

export function useGetFormTemplate(idOrName: number | string) {
  const path = isNaN(+idOrName)
    ? `form-templates/name/${idOrName}/versions/latest`
    : `form-templates/${idOrName}/versions/latest`;
  const { data, isLoading, error, get } = useApiGet<FormTemplate>(path);
  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('get form-template Error', error)),
    [error, logError]
  );
  return {
    formTemplate: data,
    loadingFormTemplate: isLoading,
    loadingFormTemplateError: error,
    getFormTemplate: get
  };
}
